export const getContactsConditions = (profile, canEditPatient) => {
  const { email, emailFake, phoneNumber, primaryContactsEnabled } = profile;

  if (primaryContactsEnabled) {
    return {
      showEmail: true,
      showPhoneNumber: true,
    };
  }

  const showEmail =
    (profile.emailConfirmed || canEditPatient) && !emailFake && email;
  const showPhoneNumber =
    (profile.phoneNumberConfirmed || canEditPatient) && phoneNumber;

  return {
    showEmail,
    showPhoneNumber,
  };
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/getContactConditions.js